// extracted by mini-css-extract-plugin
export default {"booleanProperty":"booking_detail_boolean_property-module___booleanProperty___ac26c8da"};